import React from 'react';

interface FullScreenLoaderProps {
  size?: number;
  thickness?: number;
  backdrop?: boolean;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({
  size = 60,
  thickness = 6,
  backdrop = true,
}) => {
  return (
    <>
      <div
        className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center ${
          backdrop ? 'bg-black/40' : 'bg-transparent'
        }`}
      >
        <div
          className="animate-spin rounded-full border-solid border-t-transparent border-darkPurple"
          style={{
            width: size,
            height: size,
            borderWidth: thickness,
          }}
        />
        <p className="text-lg text-darkPurple mt-4">Loading please wait ...</p>
      </div>
    </>
  );
};

export default FullScreenLoader;
